import { AfterViewInit, Component, ViewChild, inject } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatSelect, MatOption } from '@angular/material/select';
import { UserFeedback } from '@ra-state';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField } from '@angular/material/form-field';
import {
  ErrorMessageComponent,
  MultilineInputComponent,
  MainButtonComponent,
  OutlinedButtonComponent,
} from '@ra-web-tech-ui-toolkit/components';

@Component({
  selector: 'app-feedback.modal',
  styleUrls: ['./feedback.component.scss'],
  templateUrl: './feedback.component.html',
  imports: [
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    MatFormField,
    MatSelect,
    MatOption,
    ErrorMessageComponent,
    MultilineInputComponent,
    MatDialogActions,
    MainButtonComponent,
    OutlinedButtonComponent,
  ],
})
export class FeedbackComponent implements AfterViewInit {
  private readonly dialogRef = inject<MatDialogRef<FeedbackComponent>>(MatDialogRef);

  feedbackOptions = [
    {
      id: 1,
      type: 'Provide Feedback',
    },
    {
      id: 2,
      type: 'Enhancement Request',
    },
    {
      id: 3,
      type: 'Report an Issue',
    },
  ];

  @ViewChild('feedbackForm') feedbackForm: NgForm;
  @ViewChild('fdType') feedbackType: MatSelect;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.feedbackType.open();
    }, 100);
  }

  cancel(): void {
    this.close(null);
  }

  close(value): void {
    this.dialogRef.close(value);
  }

  sendFeedback(): void {
    const userFeedback: UserFeedback = {
      feedback: this.feedbackForm.value.feedbackText,
      feedbackType: this.feedbackForm.value.feedbackType,
    };
    this.close(userFeedback);
  }
  getInputHint(inputLength, validLength): string {
    return inputLength?.length + '/' + validLength;
  }
}
